<template>
  <div class="w file_detail">
    <div class="tit_p" :style="info.content?'border-bottom: 1px solid rgba(224, 229, 240, 1);':''">
        当前位置：<span @click="returnFn">服务大厅</span>
        <img src="../../assets/icon/icon-right.png" alt="" />
        详情
    </div>
    <div class="box_cont">
      <template v-if="info.content">
        <div class="title">{{ title }}</div>
        <div class="time">
          <span>发布时间：{{ info.publishTime }}</span>
          <span>印发时间：{{ info.startTime }}</span>
        </div>
        <div class="content" v-html="info.content"></div>
      </template>
      <div class="file_box">
        <div class="file_tit">附件：</div>
        <div v-for="item in info.fileList" :key="item.fileId">
          <div class="flex file">
            <img src="../../assets/icon/icon_file.png" alt="">
            <div style="flex: 1;">{{ item.fileName }}.{{ item.suffix }}</div>
            <div>
              <!-- <a href="javascript:;" @click="previewOrDownFn(item,1)">预览</a> -->
              <a href="javascript:;" @click="previewOrDownFn(item,2)">下载</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {findInstitutionFileDetailApi,downloadInstitutionFileApi} from '../../api/index'
import imgPrefix from '../../../utils/imgPrefix';
import {downloadFile,filedyl} from '../../../utils/downloadFile'
export default {
  data() {
    return {
      manageId:'',
      wid:'',
      title:'',
      info:{},
      imgPrefix,
    };
  },
  created() {
    let {manageId,wid,title} = this.$route.query;
    this.manageId = manageId;
    this.wid = wid;
    this.title = title;
    this.getDetails();
  },
  methods: {
    // 获取详情
    getDetails(){
      findInstitutionFileDetailApi({manageId: this.manageId,wid:this.wid}).then(res => {
        // console.log(res);
        this.info = res;
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    previewOrDownFn(val,num){
      // console.log(val,num,'*********');
      let dto = val;
      dto.manageId = this.manageId;
      dto.wid = this.wid;
      downloadInstitutionFileApi(dto).then(res => {
        console.log(res,'---------');
        let name = val.fileName + '.' + val.suffix;
        let file = {
          name,
          fileId: val.fileId
        }
        if(num == 1){
          // filedyl(res.data,'.'+val.suffix,val.fileId,val.fileName)
          filedyl(res.data,'.'+val.suffix,val.fileId,val.fileName)
        }else if(num == 2){
          downloadFile(res.data, val.fileName, val.suffix);
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    returnFn(){
      this.$router.go(-1)
    },
  },
};
</script>

<style scoped lang="less">
.file_detail{
  .tit_p {
      text-align: left;
      color: #7a8ba4;
      opacity: 0.8;
      padding-bottom: 1.8rem;
      margin-bottom: 46px;
      margin-top: 1.8rem;
      img {
        margin: 0 2px 2px 2px;
      }
      span{
        cursor: pointer;
      }
   }
  .box_cont{
    padding: 0 60px;
    .title{
      font-size: 24px;
      margin-bottom: 22px;
    }
    .time{
      color: rgba(122, 139, 164, 1);
      padding-bottom: 32px;
      border-bottom: 1px solid rgba(224, 229, 240, 1);
      span{
        margin-right: 30px;
      }
    }
    .content{
      text-align: left;
    }
    .file_box{
      text-align: left;
      .file_tit{
        font-size: 18px;
        padding-bottom: 20px;
        border-bottom: 1px solid rgba(224, 229, 240, 1);
      }
      .file{
        margin-top: 26px;
        justify-content: space-between;
        img{
          width: 24px;
          height: 24px;
          margin-right: 18px;
        }
        a{
          margin-left: 30px;
        }
      }
    }
  }
  
}
</style>
